// TODO refactor to factory base on scheme
import { text } from 'd3-fetch'
import { dsvFormat } from 'd3-dsv'
import alasql from 'alasql'
import axios from 'axios'
import scheme from './scheme-gobernadores'

const dataUrl = process.env.VUE_APP_DATA_URL

const votacionesTable = scheme.find(table => table.table === 'votacion')

function fetchTable(table) {
	return text(`${dataUrl}${table.file}`).then(data => {
		return importData(data, table)
	})
}

function importData(data, table) {
	// BUG DE INDICES Y DELETE AL HACER SELECT INTO FROM https://github.com/agershun/alasql/issues/1005
	/*return alasql(
		`SELECT ${table.cols
			.map(col => (col.definition.includes('INT') ? `CAST(${col.name} AS NUMBER) as ${col.name}` : col.name))
			.join(',')} INTO ${table.table} FROM ?`,
		[
			dsvFormat(';').parseRows(data, row =>
				row.slice(0, table.cols.length).reduce((previous, current, index) => {
					previous[table.cols[index].name] = current

					return previous
				}, {})
			)
		]
	)*/

	// Mejor insertar cada fila de forma manual
	dsvFormat(';').parseRows(data, row => {
		alasql(`INSERT INTO ${table.table} VALUES ?`, [
			row.slice(0, table.cols.length).reduce((previous, current, index) => {
				previous[table.cols[index].name] = table.cols[index].definition.includes('INT') ? +current : current

				return previous
			}, {})
		])
	})
}

export function loadScheme() {
	return Promise.all(
		scheme.map(table => {
			alasql(
				`CREATE TABLE ${table.table} ( 
					${table.cols.map(col => `${col.name} ${col.definition}`).join(',')},
					${table.primary}
				)`
			)
			if (table.file) {
				return fetchTable(table)
			}

			return Promise.resolve()
		})
	)
}

export function fetchVotacion(file, codElec) {
	return text(`${dataUrl}gobernadores/${file}?t=${Date.now()}`).then(data => {
		alasql(`DELETE FROM ${votacionesTable.table} WHERE cod_elec = ?`, [codElec])

		// Necesario para evitar un bug de alasql con índices
		for (let key in alasql.databases) {
			alasql.databases[key].tables[votacionesTable.table].indices = {}
		}

		return importData(data, votacionesTable)
	})
}

export function fetchData() {
	return axios(`${dataUrl}gobernadores/data.json`).then(({ data }) => data)
}

export function fetchActualizados() {
	return axios(`${dataUrl}gobernadores/actualizados.json?t=${Date.now()}`).then(({ data }) => data)
}

export function fetchElectos() {
	return axios(`${dataUrl}gobernadores/electos.json?t=${Date.now()}`).then(({ data }) => data)
}
